import type {InjectionKey} from "vue";
import type {
  GetTranslationConnectionTextHandler,
  RateTranslationConnectionTextHandler,
} from "@/composables/translate/types";
import type {CustomValidationCheckOptions, TranslationEventHandler} from "@/composables/questions/types";

export const getQuestionAnswerTranslationInjectionKey: InjectionKey<GetTranslationConnectionTextHandler> =
  Symbol("getQuestionAnswerTranslation");
export const rateQuestionAnswerTranslationInjectionKey: InjectionKey<RateTranslationConnectionTextHandler> = Symbol(
  "rateQuestionAnswerTranslation",
);
export const translationEventHandlerKey: InjectionKey<TranslationEventHandler> = Symbol("translationEvent");
export const additionalValidationChecksInjectionKey: InjectionKey<CustomValidationCheckOptions[]> =
  Symbol("additionalValidationChecks");
